import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "editor" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TargetSegmentEditor = _resolveComponent("TargetSegmentEditor")!
  const _component_ButtonTemplate = _resolveComponent("ButtonTemplate")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: _normalizeClass(['bordered', _ctx.translationStateClass, _ctx.focusedClass]),
      id: "tareget-container"
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_TargetSegmentEditor, {
          modelValue: _ctx.translationSegment,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.translationSegment) = $event)),
          setFocus: _ctx.updateFocus,
          focused: _ctx.segmentItem.focused,
          disableFormatting: _ctx.disableFormatting,
          onFocus: _ctx.focusAction,
          onTypingStarted: _ctx.onTypingStarted
        }, null, 8, ["modelValue", "setFocus", "focused", "disableFormatting", "onFocus", "onTypingStarted"])
      ]),
      _createVNode(_component_ButtonTemplate, {
        id: "clear-button",
        class: "clear-icon",
        disabled: !_ctx.showClear,
        tooltipMessage: _ctx.eraceTranslationTooltip,
        onButtonClick: _ctx.doClearTranslation
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createElementVNode("span", { class: "material-symbols-outlined" }, " cancel ", -1)
        ]))]),
        _: 1
      }, 8, ["disabled", "tooltipMessage", "onButtonClick"])
    ], 2)
  ]))
}